<template>
    <v-row justify="center" class="reportcontainer">
        <v-col cols="auto" sm="12" md="10" lg="8" class="ma-2 ma-md-5 ma-sm-2" v-if="reports_statusevents.reportChecks" id='reportwrapper'>
            <div id="messagepanel" class="float-right d-print-none">
                <v-chip color="orange darken-4" text-color="white" v-if="reports_statusevents.reportConfig && !reports_statusevents.reportConfig.enable">
                    This report is private.
                </v-chip>
                <v-btn color="secondary" class="elevation-1 ml-1 settingsbutton" dark small v-on:click="toggleConfig" v-if="!showConfig && reports_statusevents.reportConfig && reports_statusevents.reportConfig.showConfig">
                    Settings
                    <v-icon dark right>settings</v-icon>
                </v-btn>
                <v-btn color="secondary"  id="reportloginbutton" class="elevation-1 ml-1" small v-on:click="callLogin" v-if="reports_statusevents.reportConfig && !reports_statusevents.reportConfig.contactid && !noLoginBtn">
                    Login
                </v-btn>
               
            </div>
            <div v-if="reports_statusevents.reportConfig.title" v-html="makeTitle(reports_statusevents.reportConfig.title)" id="reportTitleContainer" ></div>

            <slide-up-down :active="configActive" :duration="500">
                <ReportSettings v-on:closeConfig="toggleConfig" :availablemetrics="availablemetrics" />
            </slide-up-down>

            <div id="statusoverview" v-if="reports_statusevents.reportConfig.showsummary">
                <v-card v-if="reports_statusevents.reportChecks && reports_statusevents.reportChecks.length" :class="getStatusSummaryClass" >
                    <v-card-text>
                        <v-row  justify="space-between" class="mb-2">
                            <v-col class="headline white--text pl2" >{{ itsAllGood | summaryTitle(reports_statusevents.reportConfig) }}</v-col>
                        </v-row>
                        <v-row v-if="reports_statusevents.reportConfig.showsummarydown && itsAllGood > 0">
                            <ul class="summarydowns">
                                <template v-for="job in reports_statusevents.reportChecks" >
                                    <li v-if="job.status==='down' && reports_statusevents.reportConfig.showlinks && job.public"  :key="'L-'+job._id">
                                        <router-link :to="{ name: 'check status report', params: { uuid: job.uuid, cid: job._id }}">
                                            {{ checkTitle(job) }}
                                        </router-link>
                                    </li>
                                    <li v-else-if="job.status==='down'" :key="job._id">{{ checkTitle(job) }}</li>
                                </template>
                            </ul>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card v-else class="dashboard jobrow elevation-3 mb-4 justify-center">
                    <v-card-text>
                        <v-row  justify="space-between" class="mb-2">
                            <v-col class="headline pl2" >This report does not have any checks configured.</v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </div>

            <div id="supportcontent" v-if="reports_statusevents.reportConfig.shownote && reports_statusevents.reportConfig.note && reports_statusevents.reportConfig.note.length" >
                <v-card flat class="mb-2">
                    <v-card-text>
                        <div class="note" v-html="reports_statusevents.reportConfig.note"></div>
                    </v-card-text>
                </v-card>
            </div>

            <div  v-if="reports_statusevents.reportConfig.showchecks" id="statuswrapper">
                <ReportCheckStatusTable v-if="reports_statusevents.reportConfig.checklayout === 'compact'" :runpolling="ispolling" :reportid="reportid" :showConfig="showConfig" :availablemetrics="availablemetrics"  />
                <ReportCheckStatus v-else :runpolling="ispolling" :reportid="reportid" :showConfig="showConfig" :availablemetrics="availablemetrics"  />
            </div>

            <div v-if="reports_statusevents.reportConfig.showevents && reports_statusevents.reportChecks && reports_statusevents.reportChecks.length" id='eventswrapper'>
                <ReportEvents  :runpolling="ispolling" :reportid="reportid" :showConfig="showConfig" />
            </div>

            <div id="customfooter" v-if="reports_statusevents.reportConfig.footer && reports_statusevents.reportConfig.footer.length"  v-html="reports_statusevents.reportConfig.footer" ></div>

        </v-col>
        <div v-else-if="reports_statusevents.error && reports_statusevents.error.type === 'accessphrase' ">
            <div class="text-center" style="margin-top:64px;">
                <h3 class="errormessage" style="margin-bottom: 24px;">{{reports_statusevents.error.message}}</h3>
                <v-text-field type="password" v-model="accessphrase" label="Access Phrase" outlined @keydown.enter="doAccessPhrase">  </v-text-field>
                <v-btn color="primary" class="elevation-1 ml-1" dark small @click="doAccessPhrase">Submit</v-btn>
            </div>
        </div>
        <div v-else-if="reports_statusevents.error">
            <div class="text-center" style="margin-top:64px;">
                <h3 class="errormessage">{{reports_statusevents.error.message}}</h3>
                <h3 class="errormessage">
                    Response Status: {{reports_statusevents.error.status}} {{reports_statusevents.error.statusText}}
                </h3>
                <h3 class="errormessage" v-if="reports_statusevents.error.login && !noLoginBtn">If this report exists, but is private or disabled, you may need to <a :href="'/account/sso?pn='+this.$route.fullPath">login</a>.</h3>
            </div>
        </div>

        <div v-else>
            <div class="text-center" style="margin-top:64px;">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
        </div>
    </v-row>
</template>

<script>
import { mapState } from "vuex";
import { format as date_format, parse as date_parse, subDays } from "date-fns";
import { formatDay, formatBoolean, filterId } from "../lib/filter";
import SlideUpDown from 'vue-slide-up-down'

import ReportSettings from "./Reports_Statusevents_Config";
import ReportCheckStatus from "./Reports_Statusevents_Checkstatus";
import ReportCheckStatusTable from "./Reports_Statusevents_Checkstatus_Table";
import ReportEvents from "./Reports_Statusevents_Events";

// import { addDays } from "date-fns/add_days";
// import { format as date_format } from "date-fns/format";
// import { parse as date_parse } from "date-fns/parse";

export default {
    name: "Reports_Statusevents",
    metaInfo ( ) {
        // console.log('metaInfo', this);
        return {
            title: this.getPageTitle,
            style: [{ cssText: this.getCSS }]
        }
    },
    props: {},
    components: { ReportSettings, ReportCheckStatus, ReportEvents, SlideUpDown, ReportCheckStatusTable },
    data () {
        return {
            report: "statusevents",
            reportid: (window.reportid && filterId(window.reportid)) || this.$route.params.reportid,
            accessphrase: "",
            ispolling: false,
            noLoginBtn: window.location.hostname.indexOf('nodeping.com') < 0,
            pollconfig: true,
            polljobs: true,
            showConfig: false, // This is the local toggle, reportconfig is used for detecting owner.
            showCheckConfig: false,
            availablemetrics: [
                'Uptime for today and 30 days',
                'Uptime for seven days',
                'Uptime for seven and 30 days',
                'Current response time'
            ]
        };
    },
    computed: {
        ...mapState(["currentUser", "checks", "reports_statusevents", "now"]),
        itsAllGood: function () {
            if (
                this.reports_statusevents &&
                this.reports_statusevents.reportChecks &&
                this.reports_statusevents.reportChecks.length
            ) {
                return this.reports_statusevents.reportChecks
                    .filter(job => job.enable === "active")
                    .filter(job => job.status === "down").length;
            } else {
                return false;
            }
        },
        sevenDays: function () {
            if (!this.now) return;
            let days = [this.now.date];
            let dateobj = date_parse(this.now.date);
            for (let i = 1; i < 7; i++) {
                days.push(date_format(subDays(dateobj, i), "YYYY-MM-DD"));
            }
            return days;
        },
        configActive: function () {
            return (this.showConfig && this.reports_statusevents.reportConfig && this.reports_statusevents.reportConfig.showConfig)
        },
        getCSS: function () {
            let css = ( this.reports_statusevents.reportConfig && this.reports_statusevents.reportConfig.stylecss && this.reports_statusevents.reportConfig.stylecss.length)  ?  this.reports_statusevents.reportConfig.stylecss : "";
            return css;
        },
        getPageTitle: function () {
            return ( this.reports_statusevents.reportConfig && this.reports_statusevents.reportConfig.pagetitle && this.reports_statusevents.reportConfig.pagetitle.length) ? this.reports_statusevents.reportConfig.pagetitle  : "NodePing Status Events Report";
        },
        getStatusSummaryClass: function () {
            let summaryClass = (this.itsAllGood > 0) ? "summaryblockdown" : "summaryblockup";
            return 'dashboard elevation-3 mb-4 justify-center ' + summaryClass;
        }
    },
    methods: {
        doAccessPhrase: function () {
            // console.log('doAccessPhrase');
            this.startPolling();
        },
        makeTitle: function (val) {
            if (!val || val === "") return "";
            return val.includes("<") ? val : "<h1>" + val + "</h1>";
        },
        startPolling: function (options) {
            options = options || {};
            const params = {
                reportid: this.reportid,
                skipconfig: !this.pollconfig,
                skipjobs: !this.polljobs
            };
            if(this.accessphrase && this.accessphrase.length) params.accessphrase = this.accessphrase;
            // console.log("polling", params, new Date());
            this.$store
                .dispatch("reports_statusevents/listChecks", params)
                .then(() => {
                    if (
                        this.reports_statusevents.reportConfig &&
                        this.reports_statusevents.reportConfig.showConfig
                    ) {
                        this.$store.dispatch("checks/getChecksList");
                    }

                    clearTimeout(this.$options.polling);
                    setTimeout(() => {this.ispolling = true; return true;}, 333);
                    this.$options.polling = setTimeout( this.startPolling, 60000);
                })
                .catch( (error) => {
                    console.log("Error getting checks for report");
                    this.$options.polling = setTimeout( this.startPolling, 60000);
                });
        },
        stopPolling: function () {
            // console.log("stopPolling");
            this.ispolling = false;
            if (this.$options && this.$options.polling) {
                clearTimeout(this.$options.polling);
            }
        },
        toggleConfig: function () {
            // We're freezing the config fetch from the server while the config panel is open.  There is a small chance
            // of some quirks here if the config is also being changed in another window somewhere.  At one point we
            // called startPolling always when the panel was open or closed, but on large reports this occasionally caused
            // up to 2-3 second delays.
            this.showConfig = !this.showConfig;
            this.pollconfig = !this.showConfig;
            // this.ispolling = !this.showConfig;
            if(!this.showConfig) this.startPolling();
            // setTimeout(() => {

            //     if (this.$options && this.$options.polling){
            //         clearTimeout(this.$options.polling);
            //     }
            //     this.startPolling();
            // }, 1000)
        },
        getCheckConfig: function (id) {
            // console.log(this.reports_statusevents.reportConfig);
            return { label: "foo" };
            // return _find('reports_statusevents')
        },
        callLogin: function () {
            window.location.href="/account/sso?pn="+this.$route.fullPath;
        },
        checkTitle: function (job) {
            return (job.report && job.report.label) ||          // custom label set for the check on this report.
                    job.label ||                                // the job's label
                    job.params_target ||                        // this is how we get it from the server
                   (job.parameters && job.parameters.target) || // checks added locally before server refresh
                    job._id                                     // fallback, should always exist
        }
    },
    mounted () {
        // console.log("Status Event Report mounted");

    },
    created () {
        this.startPolling();
    },
    beforeDestroy () {
        this.stopPolling();
    },
    filters: {
        formatBoolean (val) {
            return formatBoolean(val);
        },
        formatDay (val) {
            return formatDay(val, "D MMM");
        },
        formatEnabled (val) {
            return val ? "Enabled" : "Disabled";
        },
        /*
         * val should be the l field from a result record.
         */
        formatLocation (val) {
            let ts = 9999999999999;
            let loc;
            for (let k in val) {
                if (k < ts) loc = val[k];
            }
            return loc.toUpperCase();
        },
        summaryTitle (itsAllGood, reportConfig) {
            // console.log('summaryTitle', reportConfig.showsummarydown, itsAllGood)
            if(!itsAllGood) return `All Systems are Operational`;

            let colon = ( reportConfig.showsummarydown ) ? ":" : "";
            return (itsAllGood > 1) ? `${itsAllGood} Systems Down${colon}` : `1 System is Down${colon}`;
        }
    }
};
</script>

<style scoped>
#reportTitleContainer {
    margin-bottom: 12px;
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.reportcontainer {
    margin-top: 32px;
}
#messagepanel > * {
    margin-left: 12px;
}
.jobrow.disable {
    border-left: 4px solid gray;
}
.jobrow.up {
    border-left: 4px solid green;
}
.jobrow.down {
    border-left: 4px solid red;
}

.summaryblockdown {
    background-color: #e65100;
    border-color: #e65100;
}
.summaryblockup {
    background-color: #388E3C ;
    border-color: #388E3C;
}
.summarydowns {
    margin-left: 24px;
    color: white;
    font-size: 1.1em;
}

.summarydowns a {
    color: white;
}
.settingsbutton {
    z-index: 999999;
}

</style>
